module.exports = __webpack_public_path__ + "static/media/guidance_icon.0cb9c3bd.png";